import script from "./RoleTimeBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleTimeBlock.vue?vue&type=script&setup=true&lang=ts"

import "./RoleTimeBlock.vue?vue&type=style&index=0&id=16c9fd14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16c9fd14"]])

export default __exports__